<script setup lang="ts">
import { useNavigation } from '@/presentation/composables/navigation/useNavigation.ts'

// Types
type MenuItem = {
  name: string
  link: string
  icon?: string
  group?: string
  children?: Array<{
    name: string
    classrooms: Array<{
      name: string
      link: string
      params: Record<string, number>
    }>
  }>
}

interface MenuItemProps {
  item: MenuItem
  isTeacher: boolean
  isFullyOpened: boolean
  isSelected: boolean
}

// Props
const props = defineProps<MenuItemProps>()

// Navigation
const { processClick, isClassroomActive } = useNavigation()
</script>

<template>
  <div
    class="relative flex items-start"
    :class="[{ 'has-children': item.children && item.children.length > 0 }]"
  >
    <div class="w-full">
      <div class="flex">
        <i
          class="pi left-0 flex items-center justify-center p-1 cursor-pointer"
          :class="[item.icon, isSelected ? ['selected', 'text-primary'] : '', !isFullyOpened ? 'w-full text-center align-middle' : '']"
          @click="processClick(item.link)"
          v-tooltip.right="!isFullyOpened ? item.name : undefined"
        />
        <h4
          v-if="isFullyOpened"
          class="brand-heading small ml-2 flex items-center uppercase"
          :class="[{ 'cursor-pointer': !isTeacher }, isSelected ? 'selected' : '']"
          @click="processClick(item.link)"
        >
          {{ item.name }}
        </h4>
      </div>

      <!-- Sous-menu déplié -->
      <template v-if="isFullyOpened">
        <div
          v-if="item.children && item.children.length > 0"
          class="text mt-2 ml-6 flex flex-col gap-2"
        >
          <template v-for="child in item.children" :key="`child_${child.name}`">
            <template v-if="!isTeacher">
              <h5
                class="brand-heading small classroom w-full font-semibold overflow-hidden pl-2 text-ellipsis whitespace-nowrap uppercase"
                :title="child.name"
              >
                {{ child.name }}
              </h5>
            </template>
            <template v-for="classroom in child.classrooms" :key="`classroom_${classroom.name}`">
              <h6
                @click="processClick(classroom.link, classroom.params)"
                class="brand-heading small light cursor-pointer pl-2"
                :class="{ 'font-bold text-blue-400': isClassroomActive(classroom.params) }"
              >
                • {{ classroom.name }}
              </h6>
            </template>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>
